module.exports = __webpack_public_path__ + "static/img/advantages-1.89874299.png";